exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AboutView-title {\n  width: 62.5%;\n  float: left;\n  margin-left: 2.08333%;\n  margin-right: 2.08333%;\n  margin-left: 18.75%; }\n\n.AboutView-section {\n  width: 62.5%;\n  float: left;\n  margin-left: 2.08333%;\n  margin-right: 2.08333%;\n  margin-left: 18.75%;\n  margin-bottom: 24px; }\n\n.AboutView img {\n  display: inline-block;\n  width: auto;\n  height: 40px;\n  margin-right: 24px;\n  opacity: 0.9;\n  transition: opacity 0.15s ease-in-out; }\n  a:hover .AboutView img {\n    opacity: 1; }\n", ""]);

// exports
